import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CardCatalog from './CardCatalog';
import CardInfo from './CardInfo';
import CardNews from './CardNews';
import { Typography, Paper } from "@material-ui/core";
import ChipArray from './ChipArray';
// import Banner from './Banner';
import axios from 'axios';
import translate from '../other/translate.json';
import config from '../other/config';
import utils from '../other/utils';
import BannerNew from "./BannerNew";
const { serverAPI } = config;
let moment = require('moment');
require("moment/min/locales.min");


export default function MainContent(props) {
	const classes = useStyles();
	const LANG = props.language
	const [lastNewRender, setLastNewRender] = useState({ "Link": "", "Description": "", "StartDate": "" })
	const [activeChips, setActiveChips] = useState([])
	const [fakeTag, setFakeTag] = useState('')
	const [carouselApps, _carouselApps] = useState([]);

	//http://bs-ctg-app-dev.win.ftc.ru:4443/landings_apps?lang=Ru&inCu=1


	moment.locale(`${LANG.toLowerCase()}`);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			if (!didCancel) {
				let apps = await axios.get(`${serverAPI}/landings_apps?lang=${LANG}&inCu=${props.inCu}`);
				_carouselApps(apps.data)
				props.userCollection.showTestId()


			}
		}
		fetchData()
	}, [])




	function textIsLikeArray(text, indexBlock) {
		if (text && text.includes(',')) {
			let textToArr = text.split(',')
			if (activeChips.length === 0) {
				return true
			}
			let result = (textToArr.some((e) => {
				if (activeChips.includes(+e)) { return true }
				return false
			})
			)
			return result
		} else {
			return ''
		}
	}
	function checkActiveChips(inx) {
		if (activeChips.length > 0 && activeChips.includes(inx)) {
			setActiveChips(activeChips.filter((chip) => chip !== inx))
			//setFakeTag('')
		} else {
			//setFakeTag('fake')
			setActiveChips(activeChips.concat(inx))
		}
	}

	// const trackScrolling = () => {
	// }

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {

			const lastNew = await axios.get(`${serverAPI}/newevent/${LANG}`);
			if (!didCancel) {
				if (lastNew && lastNew.data && lastNew.data[0])
					setLastNewRender(lastNew.data[0])
			}
		}

		fetchData();

		return () => {
			didCancel = true;
		};
	}, [LANG]);
	const getLink = (ID_Category) => {
		switch (ID_Category) {
			case 1: { return 'solutions'; break; }
			case 2: { return 'products'; break; }
			case 3: { return 'applications'; break; }
			case 4: { return 'cloud'; break; }
			case 5: { return 'partners'; break; }
		}
	}
	let menuAppsRender1 = [];
	let menuAppsRender2 = [];
	let menuAppsRender3 = [];
	let menuAppsRender4 = [];
	let menuAppsRender5 = [];
	let menuAppsRenderArchive = [];
	let countCFT = 0;
	props.menuAppsRenderNew.forEach((item_, index) => {
		// if (textIsLikeArray(item_.TagsIDs) === true) {
		if (item_.ID_Category === 1 && item_.isArchive === 0) {
			menuAppsRender1.push(
				<Grid item key={`apps_render_element1${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 1) || (item_.TagsIDs === fakeTag && activeChips.length === 0) ? '' : 'none' }}>
					<CardCatalog header={item_.Title}
						link={item_.URL}
						catalog={'solutions'}
						// badge={'Cloud Services'} 
						img={item_?.PicturePath?.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : `${serverAPI}/9cade9b5a064f0d99ee9501f09588081/pict/Group%20597.svg`}
						// img={item_.PicturePath.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : `${serverAPI}/b9d199f754873a21320923aaf9c87210/pict/цфт-платформа сомообслуживания`}
						body={item_.BriefDescription}
						language={LANG}
						checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
					/>
				</Grid>
			)
		}
		if (item_.ID_Category === 2 && item_.isArchive === 0) {
			menuAppsRender2.push(
				<Grid item key={`apps_render_element2${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 1) || (item_.TagsIDs === fakeTag && activeChips.length === 0) ? '' : 'none' }}>
					<CardCatalog header={item_.Title}
						link={item_.URL}
						catalog={'products'}
						// badge={'Cloud Services'} 
						img={item_?.PicturePath?.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
						body={item_.BriefDescription}
						language={LANG}
						checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
					/>
				</Grid>
			)
		}

		if (item_.ID_Category === 3 && item_.isArchive === 0) {
			if (item_.URL === 'cftbank') {
				countCFT = item_.count
			}

			menuAppsRender3.push(
				<Grid item key={`apps_render_element3${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 1) || (item_.TagsIDs === fakeTag && activeChips.length === 0) ? '' : 'none' }}>
					<CardCatalog header={item_.Title}
						link={item_.URL}
						catalog={'applications'}
						// badge={'Cloud Services'} 
						img={item_?.PicturePath?.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
						body={item_.BriefDescription}
						language={LANG}
						checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
					/>
				</Grid>
			)
		}
		if (item_.ID_Category === 4 && item_.isArchive === 0) {
			menuAppsRender4.push(
				<Grid item key={`apps_render_element4${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 1) || (item_.TagsIDs === fakeTag && activeChips.length === 0) ? '' : 'none' }}>
					<CardCatalog header={item_.Title}
						link={item_.URL}
						catalog={'cloud'}
						// badge={'Cloud Services'} 
						img={item_?.PicturePath?.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
						body={item_.BriefDescription}
						language={LANG}
						checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
					/>
				</Grid>
			)
		}
		if (item_.ID_Category === 5 && item_.isArchive === 0) {
			menuAppsRender5.push(
				<Grid item key={`apps_render_element5${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 1) || (item_.TagsIDs === fakeTag && activeChips.length === 0) ? '' : 'none' }}>
					<CardCatalog header={item_.Title}
						link={item_.URL}
						catalog={'partners'}
						// badge={'Cloud Services'} 
						img={utils.hasProperty(item_.PicturePath) ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
						body={item_.BriefDescription}
						language={LANG}
						checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
					/>
				</Grid>
			)
		}
		if (item_.isArchive === 1) {
			menuAppsRenderArchive.push(
				<Grid item key={`apps_render_elementA${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 1) || (item_.TagsIDs === fakeTag && activeChips.length === 0) ? '' : 'none' }}>
					<CardCatalog header={item_.Title}
						link={item_.URL}
						catalog={getLink(item_.ID_Category)}
						// badge={'Cloud Services'} 
						img={item_.PicturePath.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
						body={item_.BriefDescription}
						language={LANG}

					/>
				</Grid>
			)
		}
		// }
	})
	// let menuAppsRender2 = props.menuAppsRenderNew.map((item_, index) => {
	// 	if (item_.ID_Category === 2){
	// 	return (
	// 		<Grid item key={`apps_render_element2${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 2) || item_.TagsIDs === fakeTag ? '' : 'none' }}>
	// 			<CardCatalog header={ item_.Title}
	// 				// badge={'Cloud Services'} 
	// 				language={LANG}
	// 				link={item_.URL}
	// 				catalog={'products'}
	// 				img={item_.PicturePath.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
	// 				body={item_.BriefDescription}
	// 				checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
	// 			/>
	// 		</Grid>
	// 	)}
	// })

	// let menuAppsRender3 = props.menuAppsRenderNew.map((item_, index) => {
	// 	if (item_.ID_Category === 3)
	// 	return (
	// 		<Grid item key={`apps_render_element3${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 3) || item_.TagsIDs === fakeTag ? '' : 'none' }}>
	// 			<CardCatalog header={item_.Title}
	// 				img={item_.PicturePath.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
	// 				//  badge={'Cloud Services'} 
	// 				language={LANG}
	// 				link={item_.URL}
	// 				catalog={'applications'}
	// 				body={item_.BriefDescription}
	// 				checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
	// 			/>
	// 		</Grid>
	// 	)
	// })

	// let menuAppsRender4 = props.menuAppsRenderNew.map((item_, index) => {
	// 	if (item_.ID_Category === 4)
	// 	return (
	// 		<Grid item key={`apps_render_element4${index}`} style={{ width: 336, display: textIsLikeArray(item_.TagsIDs, 4) || item_.TagsIDs === fakeTag ? '' : 'none' }}>
	// 			<CardCatalog header={LANG === 'Ru' ? item_.Title_Ru : item_.Title_Eng}
	// 				// badge={'Cloud Services'} 
	// 				language={LANG}
	// 				link={item_.URL}
	// 				catalog={'cloud'}
	// 				img={item_.PicturePath.length > 0 ? `${serverAPI}/${item_.HashCode}/pict/${item_.PicturePath}` : ''}
	// 				body={ item_.BriefDescription}
	// 				checkActiveChips={checkActiveChips} activeChips={activeChips} itemTags={item_.TagsIDs}
	// 			/>
	// 		</Grid>
	// 	)
	// })






	return (
		<React.Fragment>
			<Grid container spacing={3} className={classes.BannerArrayCntr}>
				<Grid item sm={9} className={classes.containerImage}>
					<BannerNew lang={LANG} carouselApps={carouselApps} />


					{/* {props.mm
						?
						// <img className={classes.imgCntr} alt="complex" src="url(./images/BannerDesctop.png)" />
						<img className={classes.imgCntr} alt="complex" src="./images/BannerDesctop.png" />
						:
						<img className={classes.imgCntr} alt="complex" src="./images/BannerDesctop.png" />
					} */}
				</Grid>

				<Grid item className={classes.containerInfo} sm={3}>
					<CardInfo count={countCFT} lang={LANG} />

					<CardNews langIsRu={LANG === 'Ru'} header={moment(lastNewRender.StartDate).format('LL') || ''} text={lastNewRender.Description} link={lastNewRender.Link} />
				</Grid>
			</Grid>

			<Grid container className={classes.ChipArrayCntr} id='ChipArrayCntr'>
				<ChipArray checkActiveChips={checkActiveChips} activeChips={activeChips} langIsRu={LANG === 'Ru'} countMenu1={props.menuAppsRender && props.menuAppsRender.menuAppsRender1 && props.menuAppsRender.menuAppsRender1.length} countMenu2={props.menuAppsRender && props.menuAppsRender.menuAppsRender2.length} countMenu3={props.menuAppsRender && props.menuAppsRender.menuAppsRender3.length} countMenu4={props.menuAppsRender && props.menuAppsRender.menuAppsRender4.length} />
				{/* work */}
			</Grid>

			{
				menuAppsRender1 && menuAppsRender1[0] && menuAppsRender1.some(el => el.props.style.display === '')
					?
					<Grid container spacing={3} className={classes.FirstCntr} style={{ marginBottom: 84 }}>
						<Grid item lg={12} md={12} sm={12}>
							<Typography className={classes.sectionTitle} variant="h5" noWrap>{translate.LetfMenu[`Solution${LANG}`]}</Typography>
						</Grid>
						{menuAppsRender1}
					</Grid>
					:
					null
			}

			{
				menuAppsRender2 && menuAppsRender2[0] && menuAppsRender2.some(el => el.props.style.display === '')
					?
					(
						<Grid container spacing={3} style={{ marginBottom: 84 }}>
							<Grid item lg={12} md={12} sm={12}>
								<Typography className={classes.sectionTitle} variant="h5" noWrap>{translate.LetfMenu[`Catalog${LANG}`]}</Typography>
							</Grid>
							{menuAppsRender2}
						</Grid>)
					:
					null
			}

			{
				menuAppsRender3 && menuAppsRender3[0] && menuAppsRender3.some(el => el.props.style.display === '')
					?
					<Grid container spacing={3} style={{ marginBottom: 84 }}>
						<Grid item lg={12} md={12} sm={12}>
							<Typography className={classes.sectionTitle} variant="h5" noWrap>{translate.LetfMenu[`Directories${LANG}`]}</Typography>
						</Grid>
						{menuAppsRender3}
					</Grid>
					:
					null
			}

			{
				menuAppsRender4 && menuAppsRender4[0] && menuAppsRender4.some(el => el.props.style.display === '')
					?
					<Grid container spacing={3} style={{ marginBottom: 84 }}>
						<Grid item lg={12} md={12} sm={12}>
							<Typography className={classes.sectionTitle} variant="h5" noWrap>{translate.LetfMenu[`Cloud${LANG}`]}</Typography>
						</Grid>
						{menuAppsRender4}
					</Grid>
					:
					null
			}
			{
				menuAppsRender5 && menuAppsRender5[0] && menuAppsRender5.some(el => el.props.style.display === '')
					?
					<Grid container spacing={3} style={{ marginBottom: 84 }}>
						<Grid item lg={12} md={12} sm={12}>
							<Typography className={classes.sectionTitle} variant="h5" noWrap>{translate.LetfMenu[`Partners${LANG}`]}</Typography>
						</Grid>
						{menuAppsRender5}
					</Grid>
					:
					null
			}
			{
				menuAppsRenderArchive.length > 0 && activeChips.length === 0//*/.some(el => el.props.style.display === '')
					?
					<Grid container spacing={3}>
						<Grid item lg={12} md={12} sm={12}>
							<Typography className={classes.sectionTitle} variant="h5" noWrap>{translate.LetfMenu[`Archive${LANG}`]}</Typography>
						</Grid>
						{menuAppsRenderArchive}
					</Grid>
					:
					null
			}
		</React.Fragment>
	);
}

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex"
	},

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	content: {
		flexGrow: 1,
		padding: 0,
		paddingTop: 28,
		marginTop: theme.spacing(12),
		// backgroundColor: 'inherit'
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	container: {
		margin: '72px auto 0',
		'&:first-child': {
			margin: '0 auto'
		},
		[theme.breakpoints.down(696)]: {
			maxWidth: 'calc(336px * 1)',
		},
		[theme.breakpoints.between(696, 1030)]: {
			maxWidth: 'calc(336px * 2)',
		},
		[theme.breakpoints.between(1030, 1366)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.between(1366, 1702)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.up(1702)]: {
			maxWidth: 'calc(336px * 4)',
		}
	},

	containerImage: {
		[theme.breakpoints.down(1702)]: {
			minWidth: '100%',
		},
	},

	containerInfo: {
		[theme.breakpoints.down(1702)]: {
			display: 'none',
		},
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemText: {
		padding: theme.spacing(1, 1)
	},

	paper: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2),
	},

	sectionTitle: {
		fontSize: 28,
		fontWeight: 500,
		marginBottom: 2
	},

	imgCntr: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		backgroundImage: 'url(./images/BannerDesctop.png)',
		borderRadius: 24
	},

	footer: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '36px 0'
	},

	ChipArrayCntr: {
		marginTop: 31,
		padding: 0,
		overflowX: 'overlay',

		[theme.breakpoints.down(1031)]: {
			position: 'absolute',
			left: 0,
			top: 364,//440//364
			margin: '0 56px',
			maxWidth: 'calc(100% - 112px)',
		},

		[theme.breakpoints.up(695)]: {
			marginBottom: 72,
			top: 364
		},

		[theme.breakpoints.down(696)]: {
			top: 378
		},

		[theme.breakpoints.down(440)]: {
			top: 440,
			margin: '0 14px',
			maxWidth: 'calc(100% - 30px)',
		},
	},

	BannerArrayCntr: {
		// marginBottom: 72,

		[theme.breakpoints.down(1031)]: {
			marginBottom: 131
		}
	},
}));
